@let loggedIn = userContextService.isLoggedIn$ | async;
@let authReady = authService.initialised$ | async;
<!-- data-auth-state is the app's authoritative auth signal. isLoggedIn$ is a
     BehaviorSubject seeded with null, so it emits false before the OIDC check
     has run: "anonymous" and "not yet resolved" are otherwise indistinguishable
     in the DOM. Gating on initialised$ separates them, which is what lets the
     e2e suite detect login state without racing the auth restore. -->
<ion-app [attr.data-version]="appVersion"
         [attr.data-auth-state]="authReady
           ? (loggedIn ? 'authenticated' : 'anonymous')
           : 'pending'">
  <app-spinner></app-spinner>
  <ion-menu #mainMenu
            contentId="main-content"
            type="overlay"
            menuId="more"
            side="end"
            swipeGesture="false">

    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>Menu</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content>

      <ion-item (click)="accountSettings()"
                (keyup)="accountSettings()">
        <ion-icon name="person" slot="start" color="light"></ion-icon>
        <ion-text>Account Settings</ion-text>
      </ion-item>

      <!-- Gated like Help: a lapsed-trial user on the paywall has
           no tab bar to leave the Settings page with (HEC-323). -->
      @if (loggedIn && userContextService.hasEffectiveRole('event.access')) {
        <ion-item (click)="navigateTo('/tabs/settings')"
                  (keyup)="navigateTo('/tabs/settings')"
                  data-testid="menu-item-settings"
                 >
          <ion-icon name="settings-outline" slot="start" color="light"></ion-icon>
          <ion-text>Settings</ion-text>
        </ion-item>
      }

      @if (userContextService.isOnUnpaidFreeTrial$ | async) {
        <ion-item (click)="navigateTo('/tabs/pricing')"
                  (keyup)="navigateTo('/tabs/pricing')"
                  data-testid="menu-item-pricing"
                 >
          <ion-icon name="pricetag" slot="start"
                    color="light"></ion-icon>
          <ion-text>Pricing</ion-text>
        </ion-item>
      }

      @if (subscriptionService.isManagementAvailable()) {
        <ion-item (click)="manageSubscription()"
                  (keyup)="manageSubscription()"
                 >
          <ion-icon name="card" slot="start"
                    color="light"></ion-icon>
          <ion-text>Manage Subscription</ion-text>
        </ion-item>
      }

      <ion-item (click)="openExternalLink('https://www.facebook.com/HomeEdCompanion/')"
                (keyup)="openExternalLink('https://www.facebook.com/HomeEdCompanion/')"
               >
        <ion-icon name="logo-facebook" slot="start" color="light"></ion-icon>
        <ion-text>HEC on Facebook</ion-text>
      </ion-item>

      <ion-item [detail]="false" (click)="openExternalLink('https://www.homeedcompanion.com/Privacy-Policy.html')"
                (keyup)="openExternalLink('https://www.homeedcompanion.com/Privacy-Policy.html')"
               >
        <ion-icon name="document-text" slot="start" color="light"></ion-icon>
        <ion-text>Privacy Policy</ion-text>
      </ion-item>

      <ion-item [detail]="false" (click)="openExternalLink('https://www.homeedcompanion.com/Terms-And-Conditions.html')"
                (keyup)="openExternalLink('https://www.homeedcompanion.com/Terms-And-Conditions.html')"
               >
        <ion-icon name="document-text" slot="start" color="light"></ion-icon>
        <ion-text>Terms of Service</ion-text>
      </ion-item>

      <ion-item (click)="openExternalLink('https://www.homeedcompanion.com/Contact.html')"
                (keyup)="openExternalLink('https://www.homeedcompanion.com/Contact.html')"
               >
        <ion-icon name="mail" slot="start" color="light"></ion-icon>
        <ion-text>Contact Us</ion-text>
      </ion-item>

      <ion-item (click)="reportProblem()"
                (keyup)="reportProblem()"
               >
        <ion-icon name="chatbox-ellipses" slot="start"
                  color="light"></ion-icon>
        <ion-text>Provide Feedback</ion-text>
      </ion-item>

      @if (loggedIn && userContextService.hasEffectiveRole('event.access')) {
        <ion-item (click)="navigateTo('/tabs/help')"
                  (keyup)="navigateTo('/tabs/help')"
                  data-testid="menu-item-help"
                 >
          <ion-icon name="information-circle" slot="start" color="light"></ion-icon>
          <ion-text>Help</ion-text>
        </ion-item>
      }
      <ion-item (click)="logout()"
                (keyup)="logout()"
                id="menu-button-logout"
               >
        <ion-icon name="log-out-outline" slot="start" color="light"></ion-icon>
        <ion-text>Logout</ion-text>
      </ion-item>
      <div class="version-container">

        <ion-text class="version-text">&copy; 2025 Home Ed Companion Ltd.  All Rights Reserved.<br/>v{{ appVersion }}</ion-text>
      </div>
    </ion-content>

  </ion-menu>

  <app-error></app-error>

  <ion-router-outlet id="main-content"></ion-router-outlet>

</ion-app>

